import { CurrencyId_Schema } from "@/services/currencies/currenciesSchema";
import { z } from "zod";

export const PriceElastic_Schema = z.object({
  currencyId: CurrencyId_Schema,
  // Allow 0 here so parse doesn't fail — zero prices are filtered out at usage sites (see ColectioOrg/api.colectio.com#403).
  price: z.number(),
  type: z.string(),
});

export const PriceNumeric_Schema = z.object({ currencyId: CurrencyId_Schema, price: z.number() });
export const PriceEmpty_Schema = z.null();
export const PriceNumericOrEmpty_Schema = z.union([PriceNumeric_Schema, PriceEmpty_Schema]);
export const Price_Schema = z.union([PriceNumeric_Schema, PriceEmpty_Schema]);
export const PricesKeyed_Schema = z.record(z.string(), PriceNumericOrEmpty_Schema);
